import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Nullable } from '@ps/utils';
import {
  AdvancedFilters,
  Feasibility,
  FeasibilityAdvancedFilterType,
  FeasibilityFilterCriteriaGroup,
  FlexibilityPrices,
  SurveySummary,
} from '@ps/survey-utils';
import { SurveyCreationPricingState } from './survey-creation-insights-state.model';

export const SurveyCreationInsightsActions = createActionGroup({
  source: 'Survey Creation Insights',
  events: {
    'Recalculate Feasibility': emptyProps(),
    'Find Surveys': props<{
      filterType: FeasibilityAdvancedFilterType;
      criteria: FeasibilityFilterCriteriaGroup[];
      dateRange: Nullable<readonly Date[]>;
    }>(),
    'Get Respondent Counts': props<{
      filterType: FeasibilityAdvancedFilterType;
      allSurveyGroupIds: number[];
      statuses: number[];
    }>(),
    'Search Criteria Surveys': props<{
      searchType: 'billingNumber' | 'surveyTitle';
      value: string;
      dateRange: Nullable<readonly Date[]>;
      countryCode?: string;
      languageCode?: string;
    }>(),
    'Search Group Surveys': props<{
      value: string;
      dateRange: Nullable<readonly Date[]>;
      countryCode?: string;
      languageCode?: string;
    }>(),
    'Apply Advanced Filters': props<{ filters: AdvancedFilters }>(),
    'Toggle Exclude From Feasible Audience': props<{
      excludeFromFeasibleAudience: boolean;
    }>(),
    'Apply Cpi Pricing': props<SurveyCreationPricingState>(),
  },
});

export const SurveyCreationInsightsApiActions = createActionGroup({
  source: 'Survey Creation Insights API',
  events: {
    'Compute Score Pending': emptyProps(),
    'Compute Score Success': props<{
      score: number;
      scorePercentage: number;
    }>(),
    'Compute Score Failure': props<{ error: string }>(),
    'Recalculate Feasibility Pending': emptyProps(),
    'Recalculate Feasibility Success': props<Feasibility>(),
    'Recalculate Feasibility Failure': props<{ error: string }>(),
    'Recalculate Feasibility With Exclusions Success': props<Feasibility>(),
    'Recalculate Feasibility With Exclusions Failure': props<{
      error: string;
    }>(),
    'Find Surveys Loading': emptyProps(),
    'Find Surveys Success': props<{ surveys: SurveySummary[] }>(),
    'Find Surveys Failure': props<{ error: string }>(),
    'Respondent Counts Success': props<{ totalCount: number }>(),
    'Respondent Counts Failure': props<{ error: string }>(),
    'Search Criteria Surveys Loading': emptyProps(),
    'Search Criteria Surveys Success': props<{ surveys: SurveySummary[] }>(),
    'Search Criteria Surveys Failure': props<{ error: string }>(),
    'Search Group Surveys Loading': emptyProps(),
    'Search Group Surveys Success': props<{ surveys: SurveySummary[] }>(),
    'Search Group Surveys Failure': props<{ error: string }>(),
    'Load Flexibility Prices Success': props<{ prices: FlexibilityPrices }>(),
    'Load Flexibility Prices Failure': props<{ error: string }>(),
  },
});
